<template>
  <v-layout child-flex>
    <v-card>
      <v-card-title>
        Tenants
        <v-spacer></v-spacer>
        <v-autocomplete
            :items="filters"
            :label="'Filter (' + (tenants.length - tenantsData.length) + ' items hidden)'"
            v-model="filter"
            item-text="text"
            item-value="value"
            multiple
            chips
            small-chips
            deletable-chips
            clearable
            @change="saveFilter"
        ></v-autocomplete>

        <span class="text-sm-body-2 ml-4">Show inactive</span> <v-switch class="pa-0 mt-4 ml-2" dense v-model="showInactive" @change="saveFilter"></v-switch>
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="tenantsData"
          :search="search"
          item-key="tenantsData._id"
          :items-per-page="10"
          class="elevation-1"
          :loading="loading"
          @dblclick:row="handleRowDoubleClick"
          :disable-pagination="tenantsData.length < 11"
          :hide-default-footer="tenantsData.length < 11"
      >
        <template v-slot:no-data>

            No results found. ({{ tenants.length }} items filtered)

        </template>
        <template v-slot:item.region="{ item }">
          <span v-if="item.region.startsWith('us')" title="us-east-1"><UsFlag title="us-east-1"/></span>
          <span v-else-if="item.region.startsWith('eu')" title="eu-west-1"><EuFlag title="eu-west-1"/></span>
          <span v-else-if="item.region.startsWith('ap')" title="ap-sydney-1"><AuFlag title="ap-sydney-1"/></span>
        </template>
        <template v-slot:item.services="{ item }">
          <ServiceStrip :item="item"/>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
              class="ma-2"
              color="green"
              small
              v-if="item.tenant_status=='1'"
          >
            Yes
          </v-chip>
          <v-chip
              class="ma-2"
              color="red"
              small
              v-if="item.tenant_status=='0'"
          >
            No
          </v-chip>
        </template>
        <template v-slot:item.licence_expires="{ item }">
          <LicenceExpiry v-if="item.coursepro_tenant"
              v-bind:expiry="item.licence_expires"
          ></LicenceExpiry>
        </template>

        <template v-slot:item.total_members="{ item }">
            <span v-if="item.total_members">
              {{ item.total_members.toLocaleString() }}
            </span>
          <span v-else>
              n/a
            </span>
        </template>

        <template v-slot:item.db_host_label="{ item }">
          <span v-if="(item.coursepro_db_host_label) || (item.insight_db_host_label)">
        <v-chip v-if="item.coursepro_db_host_label" class="ma-0" color="orange" x-small label text-color="black">
                {{ item.coursepro_db_host_label }}
        </v-chip>
              <v-chip v-if="item.insight_db_host_label" class="ma-0" color="brown" x-small label text-color="white">
                {{ item.insight_db_host_label }}
        </v-chip>
          </span>
        </template>

        <template v-slot:item.coursepro_bridge="{ item }">
          <Bridge v-if="item.coursepro_tenant"
              v-bind:bridge="item.coursepro_bridge"
              v-bind:version="item.coursepro_version"
              :showSandboxLink="false"
          />
        </template>
        <template v-slot:item.deployment_group="{ item }">
          <v-chip
              class="ma-2"
              color="red darken-4"
              v-if="item.deployment_group=='dev'"
          >
            DEV
          </v-chip>
          <v-chip
              class="ma-2"
              color="yellow darken-4"
              small
              v-if="item.deployment_group=='staging'"
          >
            STAGE
          </v-chip>
          <v-chip
              class="ma-2"
              color="green darken-4"
              small
              v-else-if="item.deployment_group=='production'"
          >
            PROD
          </v-chip>
          <v-chip
              class="ma-2"
              small
              v-else-if="item.deployment_group"
          >
            {{ item.deployment_group.toUpperCase() }}
          </v-chip>

        </template>
        <template v-slot:item.actions="{ item }">
          <v-chip
              class="ma-2"
              :to="{ name: 'tenant', params: { id: item._id }}"
              color="primary"
          >
            View
          </v-chip>
        </template>
      </v-data-table>


      <v-card-actions>
        <v-btn @click="exportTenantNames" :disabled="!listedTenants.length">
          <v-icon left>mdi-download</v-icon>
          Export tenant names
        </v-btn>
        <v-btn @click="tenantListCacheBust()">Refresh</v-btn>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                absolute
                dark
                fab
                bottom
                right
                color="pink"
                v-bind="attrs"
                v-on="on"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Add tenant</span>
            </v-card-title>

            <v-card-text>
              <v-container>

                <v-row>
                  <v-text-field v-model="newTenant.tenant" label="Name"></v-text-field>
                </v-row>
                <v-row>
                  <v-select
                      :items="regions"
                      v-model="newTenant.region"
                      label="Region"
                      dense
                  ></v-select>
                </v-row>
                <v-row>
                  <v-select
                      :items="accounts"
                      v-model="newTenant.account"
                      label="Account"
                      dense
                  ></v-select>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>

    </v-card>
  </v-layout>
</template>


<script>
import LicenceExpiry from "@/components/LicenceExpiry";
import Bridge from "@/components/Bridge";
import UsFlag from '@/components/flags/UsFlag.vue';
import EuFlag from '@/components/flags/EuFlag.vue';
import AuFlag from '@/components/flags/AuFlag.vue';
import ServiceStrip from "@/components/display/ServiceStrip.vue";


export default {
  components: {ServiceStrip, LicenceExpiry, Bridge, UsFlag, EuFlag, AuFlag},
  data() {
    return {
      filter: [],
      filters: [],
      showInactive: false,
      search: '',
      headers: [
        {text: 'Region', value: 'region'},
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'tenant_name',
        },
        {text: 'Account', value: 'account_name'},
        {text: 'Active', value: 'status'},
        {text: 'Services', value: 'services', sortable: false},

        {text: 'Deployment', value: 'deployment_group'},
        {text: 'CoursePro Version', value: 'coursepro_version'},
        {text: 'DB Version', value: 'db_version'},
        {text: 'DB Host Label', value: 'db_host_label'},
        {text: 'Bridge', value: 'coursepro_bridge'},
        {text: 'Licence', value: 'licence_expires'},
        {text: 'Members', value: 'total_members'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      regions: [],
      accounts: [],
      tenants: [],
      loading: true,
      dialog: false,
      newTenant: {
        tenant: '',
        region: 1,
        account: 1,
      },
    }
  },
  mounted() {
    this.$http.get(process.env.VUE_APP_CONTROL_API_URL + "tenant").then(response => {

      this.tenants = response.data.tenants;
      this.makeFilters();
      this.loading = false;
      const savedState = JSON.parse(localStorage.getItem('tenantListFilter'));
      if (savedState) {
        const saved = savedState.filter;
        this.filter = this.validFilters(Array.isArray(saved) ? saved : (saved ? [saved] : []));
        this.showInactive = savedState.showInactive || false;
        // Persist the cleaned filter so stale values don't come back
        this.saveFilter();
      }

    });
    this.$http.get(process.env.VUE_APP_CONTROL_API_URL + "region").then(response => {
      this.regions = response.data.regions;
    });
    this.$http.get(process.env.VUE_APP_CONTROL_API_URL + "accounts").then(response => {
      this.accounts = response.data.accounts;
    });



  },
  computed: {
    listedTenants() {
      const searchTerm = this.search.trim().toLowerCase();
      if (!searchTerm) {
        return this.tenantsData;
      }

      return this.tenantsData.filter(item => this.headers.some(header => {
        const value = item[header.value];
        return value !== null && value !== undefined && String(value).toLowerCase().includes(searchTerm);
      }));
    },
    tenantsData() {
      const active = (Array.isArray(this.filter) ? this.filter : [this.filter]).filter(Boolean);

      // Group selectors by field so we can OR within a field and AND across fields.
      // e.g. { region: ['eu-west-1', 'us-east-1'], service: ['coursepro'] }
      const groups = {};
      active.forEach(selector => {
        const idx = selector.indexOf(':');
        if (idx === -1) {
          return;
        }
        const field = selector.slice(0, idx);
        const value = selector.slice(idx + 1);
        (groups[field] = groups[field] || []).push(value);
      });

      const hasFilters = Object.keys(groups).length > 0;

      if (!hasFilters && this.showInactive) {
        return this.tenants;
      }

      return this.tenants.filter(function (item) {
        // AND across different fields, OR within the same field.
        const passesFilters = Object.keys(groups).every(field =>
          groups[field].some(value => {
            if (field === 'service') {
              return item[`${value}_tenant`] !== null;
            }
            return item[field] === value;
          })
        );

        if (!passesFilters) {
          return false;
        }

        if (this.showInactive) {
          return true;
        }
        return item.tenant_status === 1;
      }, this);
    }
  },
  methods: {
    exportTenantNames() {
      const names = this.listedTenants
          .map(tenant => tenant.tenant_name)
          .filter(Boolean);
      const blob = new Blob([names.join('\n') + (names.length ? '\n' : '')], {type: 'text/plain;charset=utf-8;'});
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'tenant-names.txt';
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    handleRowDoubleClick(event, {item}) {
      this.$router.push({name: 'tenant', params: {id: item._id}});
    },
    normalizeMembers: function (total) {
      //console.log('Got '+total+ ' normal: '+ Math.floor(total/1000)/2);
      return parseFloat(Math.floor(total / 1000) / 2);
    },
    makeFilters: function () {
      const groupedFilters = [];

      // Define groups
      const regions = [...new Set(this.tenants.map(a => a.region))].sort();
      const accounts = [...new Set(this.tenants.map(a => a.account_name))].sort();
      const groups = [...new Set(this.tenants.map(a => a.deployment_group))].sort();
      const versions = [...new Set(this.tenants.map(a => a.coursepro_version).filter(v => v))].sort();
      const dbs = [...new Set(this.tenants.map(a => a.db_version).filter(v => v))].sort();
      const dbLabels = [...new Set(this.tenants.map(a => a.coursepro_db_host_label).filter(v => v))].sort();
      const bridges = [...new Set(this.tenants.map(a => a.coursepro_bridge).filter(v => v))].sort();
      const cpEnvs = [...new Set(this.tenants.map(a => a.cpweb_name).filter(v => v))].sort();
      const insightEnvs = [...new Set(this.tenants.map(a => a.insight_web_name).filter(v => v))].sort();
      const commsportalEnvs = [...new Set(this.tenants.map(a => a.commsportal_web_name).filter(v => v))].sort();

      const services = [
        { text: 'CoursePro', value: 'coursepro' },
        { text: 'HomePortal2', value: 'homeportal2' },
        { text: 'Strive', value: 'strive' },
        { text: 'Organisation Portal', value: 'organisation' },
        { text: 'Parent Portal', value: 'parentportal' },
        { text: 'Comms Portal', value: 'commsportal' },
        { text: 'Insight', value: 'insight' },
    ];

      // Push grouped filters to the array
      if (regions.length) {
        groupedFilters.push({ text: 'Region', disabled: true });
        regions.forEach(value => {
          groupedFilters.push({ text: value, value: 'region:' + value });
        });
      }

      if (groups.length) {
        groupedFilters.push({ text: 'Group', disabled: true });
        groups.forEach(value => {
          groupedFilters.push({ text: value, value: 'deployment_group:' + value });
        });
      }

      if (accounts.length) {
        groupedFilters.push({ text: 'Account', disabled: true });
        accounts.forEach(value => {
          groupedFilters.push({ text: value, value: 'account_name:' + value });
        });
      }

      if (services.length) {
        groupedFilters.push({ text: 'Service', disabled: true });
        services.forEach(item => {
          groupedFilters.push({ text: item.text, value: 'service:' + item.value });
        });
      }

      if (versions.length) {
        groupedFilters.push({ text: 'Version', disabled: true });
        versions.forEach(value => {
          groupedFilters.push({ text: value, value: 'coursepro_version:' + value });
        });
      }

      if (dbs.length) {
        groupedFilters.push({ text: 'CP DB Version', disabled: true });
        dbs.forEach(value => {
          groupedFilters.push({ text: value, value: 'db_version:' + value });
        });
      }

      if (dbLabels.length) {
        groupedFilters.push({ text: 'CP DB Label', disabled: true });
        dbLabels.forEach(value => {
          groupedFilters.push({ text: value, value: 'coursepro_db_host_label:' + value });
        });
      }

      if (bridges.length) {
        groupedFilters.push({ text: 'CP Bridge', disabled: true });
        bridges.forEach(value => {
          groupedFilters.push({ text: value, value: 'coursepro_bridge:' + value });
        });
      }

      if (cpEnvs.length) {
        groupedFilters.push({ text: 'CP Env', disabled: true });
        cpEnvs.forEach(value => {
          groupedFilters.push({ text: value, value: 'cpweb_name:' + value });
        });
      }

      if (insightEnvs.length) {
        groupedFilters.push({ text: 'Insight Env', disabled: true });
        insightEnvs.forEach(value => {
          groupedFilters.push({ text: value, value: 'insight_web_name:' + value });
        });
      }

      if (commsportalEnvs.length) {
        groupedFilters.push({ text: 'Comms Portal Env', disabled: true });
        commsportalEnvs.forEach(value => {
          groupedFilters.push({ text: value, value: 'commsportal_web_name:' + value });
        });
      }

      // Assign the final array to filters
      this.filters = groupedFilters;
    },
    saveFilter() {
      // Save both filter and showInactive to local storage
      const state = {
        filter: this.filter,
        showInactive: this.showInactive
      };
      localStorage.setItem('tenantListFilter', JSON.stringify(state));

    },
    validFilters(selected) {
      // Keep only selections that are still offered as options. A saved value
      // for something that no longer exists (e.g. a removed environment) would
      // otherwise hide every tenant while being invisible, and so impossible
      // to clear, in the autocomplete.
      const available = new Set(this.filters.filter(f => f.value).map(f => f.value));
      return selected.filter(value => available.has(value));
    },
    tenantListCacheBust: function () {
      this.$http.get(
          process.env.VUE_APP_CONTROL_API_URL + "tenant/refresh"
      ).then(response => {
        console.log(response);
        this.loading = true
        this.tenants = [];
        this.$http.get(process.env.VUE_APP_CONTROL_API_URL + "tenant").then(response => {
          this.tenants = response.data.tenants;
          this.makeFilters();
          this.filter = this.validFilters(this.filter);
          this.saveFilter();
          this.loading = false;
        });
      });
    },
    save() {
      this.$http.put(
          process.env.VUE_APP_CONTROL_API_URL + "tenant/",
          this.newTenant
      ).then(response => {
        this.$toast.success('Successfully created tenant `' + response.data.tenant + '`');
        this.$router.push('/tenant/' + response.data.id);
      })
          .catch(error => {
            if (error.response && error.response.status === 400) {
              this.$toast.error(error.response.data.msg);
            }
          });
      this.close()
    },
    close() {
      this.dialog = false;
    },
  },
  name: "tenant-list"
}

</script>

<style scoped>
.flag-icon {
  width: 30px; /* Set the desired width */
  height: 20px; /* Set the desired height */
}
/* Style the label of the v-select */
.v-input__control {
  background-color: #f9f9f9; /* Example background */
}



</style>
